import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Service } from '../../../../../../redux/services/types';

export const useRedirectAfterDeletion = (service: Service, isSuccess: boolean) => {
  const history = useHistory();

  useEffect(() => {
    if (isSuccess) {
      const urlToRedirectTo = service.type === 'Consultation' ? '/services/consultations' : '/services';
      history.replace(urlToRedirectTo);
    }
  }, [isSuccess, history, service.type]);
};
